<template>
  <div class="box_serve mt-10" style="padding:20px;">
    <n-empty v-if="JSON.stringify(data) === '{}' ? true : false" description="暂无服务评价"></n-empty>
    <el-row :gutter="24">
      <el-col :span="24">
        <div class="biaoti_serve" style="text-align: center">{{ data.titile }}</div>
      </el-col>
      <el-col :span="24">
        <div class="biaoti_serve">{{ data.tips }}</div>
      </el-col>
      <el-col :span="24">
        <div v-for="(item, index) in data.subjects" :key="index" style="margin-left: 20px">
          <div v-if="item.category === '2'" class="ti_fontSize">单选题</div>
          <div v-if="item.category === '3'" class="ti_fontSize">多选题</div>
          <div v-if="item.category === '1'" class="ti_fontSize">判断题</div>
          <div v-if="item.category === '4'" class="ti_fontSize">问答题</div>

          <div style="margin-left: 10px">
            <span>{{ index + 1 }}. </span> <span>{{ item.titile }}</span>
            <span style="color: red" v-if="item.isRequired === true">*</span>
          </div>

          <div v-for="(items, indexs) in item.options" :key="indexs">
            <!--            单选题 判断题-->
            <div v-if="item.category === '1' || item.category === '2'" style="margin-left: 30px">
              <el-radio-group v-model="item.radio">
                <el-radio :label="items.content">{{ items.content }}</el-radio>
              </el-radio-group>
            </div>
            <!--            多选题-->
            <div v-if="item.category === '3'" style="margin-left: 30px">
              <el-checkbox v-model="items.fuxuankuang">{{ items.content }}</el-checkbox>
            </div>
          </div>
          <!--          问答题-->
          <div v-if="item.category === '4'" style="margin-left: 30px">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="item.answerContent">
            </el-input>
          </div>
        </div>
        <div class="saveServe" v-if="data.answerCount === 0">
          <el-button class="allbtncolor" type="primary" @click="submit">提交</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { websitePaper, getUserInfoApi, submitPaper, websitePaperDiao } from '@/api/index';
export default {
  data () {
    return {
      data: {},
    };
  },
  methods: {
    submit () {
      console.log('保存');
      this.save();
    },
    save () {
      console.log('处理数据');
      var objRow = {
        tips: this.data.tips,
        titile: this.data.titile,
        paperId: this.data.paperId, // 试卷id
        paperEndDay: this.data.paperEndDay, // 问卷---调查结束日期
        paperStartDay: this.data.paperStartDay, // 问卷--调查开始日期
        paperYear: this.data.paperYear, // 问卷--调查年度
        targetId: this.data.targetId, // 回答问题的人的ID
        targetType: this.data.targetType, // 回答问题的人类型：1 学生 2 讲师 3 班主任 4 专家
        answerId: this.data.answerId, // 回答过了,带id, 否自没有id
        answerCount: this.data.answerCount,
        paperType: this.data.paperType,
        subjects: [],
      };
      for (let i = 0; i < this.data.subjects.length; i++) {
        let dan = this.data.subjects[i];
        let item = {};
        let shuzu = [];
        for (let j = 0; j < dan.options.length; j++) {
          let xuandan = dan.options[j];
          let xuan = {};
          if (dan.category === '2' || dan.category === '1') {
            if (xuandan.content === dan.radio) {
              xuandan.checked = 1;
            } else {
              xuandan.checked = 0;
            }
          }
          if (dan.category === '3') {
            if (xuandan.fuxuankuang) {
              xuandan.checked = 1;
            } else {
              xuandan.checked = 0;
            }
          }
          xuan = {
            content: xuandan.content,
            checked: xuandan.checked,
            fuxuankuang: xuandan.fuxuankuang,
            paperId: xuandan.paperId, // 试卷id
            sortNum: xuandan.sortNum, // 排序号

            createTime: xuandan.createTime,
            createUser: xuandan.createUser,
            id: xuandan.id,
            isDeleted: xuandan.isDeleted,
            status: xuandan.status,
            subjectId: xuandan.subjectId,
            updateTime: xuandan.updateTime,
            updateUser: xuandan.updateUser,
          };
          shuzu.push(xuan);
        }
        item = {
          category: dan.category, // 题目类型 1、判断、2单选、3多选、4问答单行 5问答多行
          isRequired: dan.isRequired, // 是否必答题
          isStatistics: dan.isStatistics, // 是否能够统计 Y是 N否
          index: i,
          titile: dan.titile, // 题目标题
          tips: dan.tips, // 题目说明
          radio: dan.radio, // 单选判断
          options: shuzu, // 题目下的选项
          answerContent: dan.answerContent, // 问答题的回复内容
          paperId: dan.paperId, // 试卷id
          sortNum: dan.sortNum, // 排序号
          createTime: dan.createTime,
          createUser: dan.createUser,
          status: dan.status,
          isDeleted: dan.isDeleted,
          updateTime: dan.updateTime,
          updateUser: dan.updateUser,
          id: dan.id,
        };
        objRow.subjects.push(item);
      }
      console.log('!!!!!!!!!!!!!!!!!!!!!');
      // console.log(objRow);
      //  判断 是否 已答完
      for (let p = 0; p < objRow.subjects.length; p++) {
        // console.log(objRow.subjects[p]);
        //  判断是否有必答题
        if (objRow.subjects[p].isRequired) {
          // 单选题 判断
          if (objRow.subjects[p].category === '2' || objRow.subjects[p].category === '1') {
            if (objRow.subjects[p].radio === '') {
              return this.$message({
                type: 'error',
                message: `请把第 ${objRow.subjects[p].index + 1} 道题做完,在提交`,
              });
            }
          } else if (objRow.subjects[p].category === '3') {
            let sum = 0;
            for (let m = 0; m < objRow.subjects[p].options.length; m++) {
              if (objRow.subjects[p].options[m].checked === 0) {
                sum++;
              }
            }
            if (objRow.subjects[p].options.length === sum) {
              return this.$message({
                type: 'error',
                message: `请把第 ${objRow.subjects[p].index + 1} 道题做完,在提交`,
              });
            }
          } else if (objRow.subjects[p].category === '4') {
            if (objRow.subjects[p].answerContent === '') {
              return this.$message({
                type: 'error',
                message: `请把第 ${objRow.subjects[p].index + 1} 道题做完,在提交`,
              });
            }
          }
        }
      }
      console.log('可以提交了');
      //  保存数据
      submitPaper(objRow).then(res => {
        console.log(res);
        if (res.success === true) {
          this.$message({
            type: 'success',
            message: '提交成功',
          });
        } else {
          this.$message({
            type: 'error',
            message: '提交失败',
          });
        }
      });
    },
  },
  mounted () {
    console.log('服务评价加载完毕');
    websitePaperDiao({ code: 12 }).then(res => {
      if (res.success === true) {
        if (JSON.stringify(res.data) === '{}') {
          console.log(this.data);
          return console.log('空');
        }
        this.data = res.data;
        console.log(this.data.type);
        // 处理后天返回的数据
        if (this.data.answerCount !== 0) {
          console.log('已经不是第一次了');
          // 取出返回值
          for (let q = 0; q < this.data.subjects.length; q++) {
            // 判断 单选
            if (this.data.subjects[q].category === '1' || this.data.subjects[q].category === '2') {
              let options = this.data.subjects[q].options;
              for (let qq = 0; qq < options.length; qq++) {
                if (options[qq].checked === 1) {
                  this.data.subjects[q].radio = options[qq].content;
                }
              }
            } else if (this.data.subjects[q].category === '3') {
              let fu = this.data.subjects[q].options;
              for (let f = 0; f < fu.length; f++) {
                if (fu[f].checked === 1) {
                  fu[f].fuxuankuang = true;
                }
              }
            }
          }
        }
      } else {
        this.$message({
          type: 'error',
          message: res.msg,
        });
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.box_serve {
  border: 1px solid #d1d5db;
}
.biaoti_serve {
  height: 50px;
  font-size: 20px;
}
.ti_fontSize {
  font-size: 16px;
  font-weight: 550;
}
.saveServe {
  height: 100px;
  line-height: 100px;
  text-align: center;
}
</style>
